import React, { useEffect, useState } from 'react';
import { HOME } from '../../../routes/paths';
import { MasterMessage } from '../../../masters/masterMessages';
import { useNavigate } from 'react-router-dom';
import StepperGeneral from '../../components/general/stepper/stepper';
import ContactInformation from './steps/contactInformation';
import Typification from './steps/typification';
import StepperReset from '../../components/general/stepper/stepperReset';
import { asyncGetIdentification } from '../../../services/params.service';
import Loading from '../../components/general/loading/loading';
import { asyncCities } from '../../../services/general.service';
import { types } from '../../../redux/types';
import { useDispatch, useSelector } from 'react-redux';
import { asyncGetTipification } from '../../../services/caseReport.service';
import { RootState } from '../../../redux/store';
import ListView from '../../components/views/listView';
import SearchIcon from '@mui/icons-material/Search';
import Grid from '@mui/material/Grid';
import FieldText from '../../components/general/fields/fieldText';
import ModalHistorical from './modalHistorical';

const CaseReport = () => {
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const { logUser } = useSelector((state: RootState) => state.general);
    const { id: idUserLog, name, surname, username } = logUser || {};
    const { titleNew } = MasterMessage.caseReport;
    const [lengthSteps, setLengthSteps] = useState<number>(0);
    const [infoContact, setInfoContact] = useState<any>(undefined);
    const [identifications, setIdentifications] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingSearch, setLoadingSearch] = useState<boolean>(false);
    const [cities, setCities] = useState<
        { id: number; name: string; department: object }[]
    >([]);
    const [globalTypifications, setGlobalTypifications] = useState<any[]>([]);
    const [numberCase, setNumberCase] = useState<string>('');
    const [globalId, setGlobalId] = useState<string>('');
    const [formikTouched, setFormikTouched] = useState<boolean | undefined>(
        false
    );
    const [formikErrors, setFormikErrors] = useState<string | undefined>('');
    const [formikValues, setFormikValues] = useState<string | undefined>('');
    const [disabledGlobal, setDisabledGlobal] = useState<boolean>(false);
    const [enabledHistorical, setEnabledHistorical] = useState<boolean>(true);
    const [openModal, setOpenModal] = useState<boolean>(false);

    const validateTypeId = (info: any) => {
        if (info.habeasData === 0) {
            info.habeasData = 2;
        }
        if (info.minor === 0) {
            info.minor = 2;
        }
        if (info?.typeId > 0 && info?.numberId) {
            setEnabledHistorical(false);
            const data =
                identifications.filter(
                    (row) => row.value.toString() === info?.typeId.toString()
                )[0] || [];
            if (data) {
                if (info?.tutorIdType > 0) {
                    const dataTutor =
                        identifications.filter(
                            (row) =>
                                row.value.toString() ===
                                info?.tutorIdType.toString()
                        )[0] || [];
                    if (dataTutor) {
                        info.tutorIdType = dataTutor.id;
                    }
                }
                info.typeId = data.id;
                setInfoContact(info);
            }
        } else {
            setInfoContact(info);
        }
    };

    const validateReset = (value: boolean) => {
        if (value) {
            setGlobalId('');
            setDisabledGlobal(value);
            setEnabledHistorical(true);
        }
    };

    const steps = [
        {
            label: 'Información de contacto',
            component: (
                <ContactInformation
                    infoContact={infoContact}
                    userLog={idUserLog}
                    globalId={globalId}
                    citiesInfo={cities}
                    stepsLength={lengthSteps}
                    identifications={identifications}
                    onInfoContact={(info) => validateTypeId(info)}
                    onLoading={(value) => setLoading(value)}
                    onFormikTouchedGlobalId={(value) => setFormikTouched(value)}
                    onFormikErrorsGlobalId={(value) => setFormikErrors(value)}
                    onFormikValueGlobalId={(value) => setFormikValues(value)}
                />
            ),
        },
        {
            label: 'Tipificación',
            component: (
                <Typification
                    infoContact={infoContact}
                    userLog={idUserLog}
                    nameLog={name}
                    surnameLog={surname}
                    usernameLog={username}
                    globalId={globalId}
                    identifications={identifications}
                    globalTypifications={globalTypifications}
                    stepsLength={lengthSteps}
                    onNumberCase={(value) => setNumberCase(value)}
                    onFormikTouchedGlobalId={(value) => setFormikTouched(value)}
                    onFormikErrorsGlobalId={(value) => setFormikErrors(value)}
                    onFormikValueGlobalId={(value) => setFormikValues(value)}
                    onFormikReset={(value) => validateReset(value)}
                />
            ),
        },
    ];

    useEffect(() => {
        dispatch({ type: types.resetStepper });

        window.addEventListener('beforeunload', alertUser);
        return () => {
            window.removeEventListener('beforeunload', alertUser);
        };
    }, []);

    useEffect(() => {
        setLengthSteps(steps.length);

        if (identifications.length === 0) {
            asyncGetIdentification().then((body: any) => {
                setIdentifications(body);
            });
        }

        if (globalTypifications.length === 0) {
            asyncGetTipification().then((body: any) => {
                if (body) setGlobalTypifications(body);
            });
        }

        if (infoContact) {
            setLoading(false);
            if (infoContact?.department && cities.length === 0) {
                setLoadingSearch(true);
                asyncCities(infoContact?.department)
                    .then((body: any) => {
                        if (body) {
                            setCities(body);
                        }
                    })
                    .finally(() => setLoadingSearch(false));
            }
        }
    }, [steps, infoContact, globalTypifications, identifications]);

    const alertUser = (e: any) => {
        e.preventDefault();
        e.returnValue = '';
    };

    const onClickReset = () => {
        dispatch({ type: types.resetStepper });
        setInfoContact(undefined);
        setCities([]);
        setNumberCase('');
        setDisabledGlobal(false);
    };

    const validateHistorical = () => {
        setOpenModal(true);
    };

    return (
        <>
            {loading || loadingSearch ? (
                <Loading />
            ) : (
                <>
                    <ListView
                        title={titleNew}
                        titleButtonAdd={'Histórico'}
                        startIconButtonAdd={<SearchIcon color="secondary" />}
                        disableAdd={enabledHistorical}
                        onClickAdd={() => validateHistorical()}
                        onClickBack={() => navigate(HOME)}
                        disableDataGrid={true}
                        enabledSearch={!disabledGlobal}
                        searchField={
                            <Grid
                                container
                                spacing={{ xs: 1.5, md: 1.5 }}
                                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                            >
                                <Grid item xs={8}>
                                    <FieldText
                                        label="Global Id"
                                        name="globalId"
                                        size="small"
                                        touched={formikTouched}
                                        errors={formikErrors}
                                        value={formikValues}
                                        onChange={(value: any) =>
                                            setGlobalId(value?.target?.value)
                                        }
                                    />
                                </Grid>
                            </Grid>
                        }
                    />
                    <StepperGeneral steps={steps} />
                    <StepperReset
                        subTitle={`Caso ${numberCase} creado exitosamente`}
                        onClick={onClickReset}
                        stepsLength={lengthSteps}
                    />
                </>
            )}
            {openModal && (
                <ModalHistorical
                    open={openModal}
                    onClose={(value) => setOpenModal(value)}
                    numberId={infoContact?.numberId}
                />
            )}
        </>
    );
};

export default CaseReport;
